<template>
  <div class="course__tile">
    <header>
      <div class="name__display">
        <favorite-button :course="favoriteInfo"></favorite-button>
        <a :href="course.url"
           :target="linksInNewTab ? '_blank' : '_self'"
        >
          {{ course.shortName }}
        </a>
      </div>
      <analytics-button
          :has-analytics="course.hasAnalytics"
          :course-id="course.courseId"
      />
    </header>
    <section class="icons__container">
      <tile-badge :count="course.msg" icon="mdi-email"></tile-badge>
      <tile-badge :count="course.resource" icon="mdi-file-document"></tile-badge>
      <a :target="linksInNewTab ? '_blank' : '_self'"
         :href="calendarUrl"  v-if="course.upcomingEventsCount!==0">
        <tile-badge :count="course.upcomingEventsCount" icon="mdi-calendar-month"></tile-badge>
      </a>
      <tile-badge v-else :count="course.upcomingEventsCount" icon="mdi-calendar-month"></tile-badge>
      <tile-badge :count="course.other" icon="mdi-school"></tile-badge>
    </section>
    <footer>
      <div class="grade__corner">
        <v-tooltip right v-if="course.gradeRaw !== null">
          <template v-slot:activator="{ on, attrs }">
            <p v-on="on" v-bind="attrs">
              {{ $t('course.courseGrade.label') }}
              <span>
                {{ roundedGrade }}
              </span>
              / {{ course.courseGrade.maxGrade}}
            </p>
          </template>
          <span>{{ course.courseGrade.finalGrade}}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip right v-if="course.completionRaw !== null">
          <template v-slot:activator="{ on, attrs }">
            <p v-on="on" v-bind="attrs">
              {{ $t('course.completion.label') }}
              <span>
                {{ completionFloor }}
              </span>%
            </p>
          </template>
          <span>{{ course.completion.ratio }}</span>
        </v-tooltip>
      </div>
      <v-progress-linear
            :value="completionFloor"
            :color="userColor"
            :height="15"
            background-color="eoleGrey"
      >
      </v-progress-linear>
    </footer>
  </div>
</template>

<script>

  import {mapGetters} from 'vuex'
  import {getCalendarUrl} from '@/assets/constants'
  import pick from 'lodash/fp/pick'

  export default {
    name: "CourseTile",
    props: {
      course: {
        type: Object,
        required: true
      }
    },
    components: {
      AnalyticsButton: () => import('@/components/course/AnalyticsButton'),
      FavoriteButton: () => import('@/components/course/FavoriteButton'),
      TileBadge: () => import('@/components/course/TileBadge')
    },
    computed:{
      ...mapGetters(['linksInNewTab', 'userColor']),
      favoriteInfo() {
        return pick(
            ['isFavorite', 'shortName', 'courseId', 'instanceId'],
            this.course
        )
      },
      calendarUrl() {
        return getCalendarUrl(this.course.url, this.course.courseId)
      },
      completionFloor() {
        return Math.floor(this.course.completion.percentage)
      },
      roundedGrade() {
        return Math.round(this.course.courseGrade.finalGrade * 10) / 10
      }
    },
  }
</script>

<style lang="scss" scoped>

$widthPadding: 15px;

.course__tile {
  background-color: rgba(255, 255, 255, 0.85);
  border: 1px solid #CEE2E6;
  opacity: 1;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 400px;
  margin: 10px;
  padding: 10px $widthPadding 0;

  header{
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;

    .name__display {

      a {
        text-decoration: none;
        color: black;
        font-size: 17px;
        font-weight: 700;
        margin-left: 5px;
        padding: 4px 0 0;

        &:hover, &:active {
          text-decoration: underline;
        }
      }
    }
  }

  section.icons__container {
    display: grid;
    grid-template-columns: repeat(4, 2fr);
    margin: 10px 0;
  }

  footer {
    display: flex;
    align-items: flex-end;
    min-height: 50px;
    position: relative;
    padding-bottom: 15px;

    p {
      margin-bottom: 0;

      &:last-child {
        margin-bottom: 8px;
      }
    }

    .v-progress-linear {
      bottom: 0;
      left: calc(-1px - #{$widthPadding});
      width: calc(100% + 2 * #{$widthPadding} + 2px);
      position: absolute;
    }
  }
}

</style>
